// extracted by mini-css-extract-plugin
module.exports = {"tab_parent_active":"tab_tab_parent_active__Nrx7X","tab_parent_inactive":"tab_tab_parent_inactive__v7Hd3"};